import { splitProps } from 'solid-js'

type Props = ComponentProps<'svg'>

export function Svg(props: Props) {
  return <Presenter {...props} />
}

function Presenter(props: Props) {
  const [component, attributes] = splitProps(props, ['children'])
  return <svg {...attributes}>{component.children}</svg>
}
